import React, { useState, useEffect } from 'react';
import YouTubeHoverPlay from './YouTubeHoverPlay';

const GalleryVideo = () => {
     const [slideList, SetSlideList] = useState([]);
    const [slideListTw, SetSlideListTw] = useState([]);


      useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/video_galery`)
                    .then((res) => {
                        return res.json();
                    })
                    .then((datas) => {
                        //console.log(datas);
                        SetSlideList(datas.data);
                    });

          fetch(`${process.env.REACT_APP_API_ENDPOINT}/video_galery_tw`)
              .then((res) => {
                  return res.json();
              })
              .then((datas) => {
                  //console.log(datas);
                  SetSlideListTw(datas.data);
              });
    }, []);
     

    return (
        <div class="max-w-full px-0 py-0 sm:px-6 lg:px-0 lg:py-0 mx-auto bg-[#ffffff]">
            <section class="text-gray-600 body-font pb-20">
                <div class="container px-5 py-5 mx-auto">
                    <div class="flex flex-col text-center w-full mb-20">
                        <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Selamat datang diwebsite JDIH</h1>
                    </div>
                    <div class="flex flex-wrap -m-10 justify-center">
                        <div class="relative flex min-h-screen flex-col bg-white rounded-lg">
                            <div className="bg-white text-gray-900 font-sans">
                               
                                {/* Main Section */}
                                <div className="flex w-full">
                                    <div class="wrap-video">
                                        <YouTubeHoverPlay videoId="Nyzd7kCENEw" />
                                    </div>
                                </div>

                                {/* Footer Social Media */}
                                <div className="bg-gray-100 p-4 flex flex-wrap gap-4 justify-center">
                                    <a href="#" className="bg-blue-600 text-white px-4 py-2 rounded-md">
                                        Facebook
                                    </a>
                                    <a href="#" className="bg-blue-400 text-white px-4 py-2 rounded-md">
                                        Twitter
                                    </a>
                                    <a href="#" className="bg-pink-500 text-white px-4 py-2 rounded-md">
                                        Instagram
                                    </a>
                                    <a href="#" className="bg-red-600 text-white px-4 py-2 rounded-md">
                                        YouTube
                                    </a>
                                </div>
                            </div>
                            {/*<div class="min-h-28">
                                <div class="mx-auto py-4">
                                    <div class="gap-6 mt-8 mx-4 md:flex">
                                        {slideList.map((data, index) => (
                                            <div class="md:w-1/2">
                                                <div class="wrap-video">
                                                    <YouTubeHoverPlay videoId={data.id_yt} />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div class="gap-6 mt-8 mx-4 md:flex">
                                    {slideListTw.map((datatw, index) => (
                                        <div class="md:w-1/2">
                                            <div class="wrap-video">
                                                <YouTubeHoverPlay videoId={datatw.id_yt} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div><br />*/}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default GalleryVideo;
